import { Injectable } from '@angular/core';
import {Http} from '@angular/http';
import {Service} from "../shared/services/service";
import {Funcoes} from "../funcoes";

@Injectable()
export class LaudosCDService extends Service{

  protected url: string = this.dominio+"/adm/laudos-cd/";

  constructor(protected http: Http, protected func: Funcoes) {
    super();
  }

  ordenaFotos(fotos, id){
    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id+'/ordena-fotos/', JSON.stringify(fotos), {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  apagaFoto(id_laudo_cd, id_foto){

    let headers = this.getHeaderLogado();

    return this.http.delete(this.url + id_laudo_cd+'/fotos/'+id_foto, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  girarFoto(id_laudo_cd, id_foto){

    let headers = this.getHeaderLogado();

    return this.http.put(this.url + id_laudo_cd+'/fotos/'+id_foto+'/girar', {}, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  // solicita todas as fotos em um arquivo zip
  zipFotos(id){
    let headers = this.getHeaderLogado();

    return this.http.get(this.url + id+'/fotos/zip/', {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  apagaFotoTermografo(id_laudo_cd, tg_id?: string, index?: number){
    let headers = this.getHeaderLogado();
    let url = this.url + id_laudo_cd + '/delete-termografo';
    let queryParams = [];
    if (tg_id) {
      queryParams.push('tg_id=' + tg_id);
    }
    if (index) {
      queryParams.push('index=' + index);
    }
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    return this.http.delete(url, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }

  girarFotoTermografo(id_laudo_cd, tg_id?: string, index?: number){
    let headers = this.getHeaderLogado();
    let url = this.url + id_laudo_cd + '/termografo/girar';
    let queryParams = [];
    if (tg_id) {
      queryParams.push('tg_id=' + tg_id);
    }
    if (index) {
      queryParams.push('index=' + index);
    }
    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&');
    }

    return this.http.put(url, {}, {headers})
      .map(res => {
        let json = res.json();
        if(json.Success){
          this.trataSucesso(res);
        }else{
          this.trataErro(json);
        }
        return json;
      });
  }
  enviarLaudoParaCliente(id) {
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id + '/notificar', {}, {headers})
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  enviarLaudoParaEmailEspecifico(id, email) {
    let headers = this.getHeaderLogado();

    return this.http.post(this.url + id + '/notificar-com-email', JSON.stringify({ email }), { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  setStatus(id_laudo, id_status, notificar: boolean = true) {
    let headers = this.getHeaderLogado();
    let url = this.url + id_laudo + "/status/" + id_status + "/";

    if (!notificar) {
      url += "nao-notifica";
    }

    return this.http
      .put(url, {}, { headers })
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  setValor(id_laudo, valor) {
    let headers = this.getHeaderLogado();

    return this.http
      .put(
        this.url + id_laudo + "/alterar-valor/", JSON.stringify({"valor": valor}),
        { headers }
      )
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  faturarLaudo(id_laudo, data) {
    let headers = this.getHeaderLogado();

    return this.http
      .put(
        this.dominio + "/adm/faturas/faturar-laudo-cd/" + id_laudo, JSON.stringify({"data": data}),
        { headers }
      )
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  downloadZipPdfs(ids: string[]) {
    let headers = this.getHeaderLogado();

    return this.http
      .post(
        this.url + "download-zip", JSON.stringify({ ids: ids }),
        { headers }
      )
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

  importarTermografo(id_laudo_cd, source_laudo_id, source_tg_id, target_tg_id, source_type?: string) {
    let headers = this.getHeaderLogado();
    let body: any = { source_laudo_id, source_tg_id, target_tg_id };
    if (source_type) {
      body.source_type = source_type;
      body.source_id = source_laudo_id;
    }
    return this.http
      .post(
        this.url + id_laudo_cd + '/importar-termografo',
        JSON.stringify(body),
        { headers }
      )
      .map(res => {
        let json = res.json();
        if (json.Success) {
          this.trataSucesso(res);
        } else {
          this.trataErro(json);
        }
        return json;
      });
  }

}





// WEBPACK FOOTER //
// ./src/app/laudos-cd/laudos-cd.service.ts